import { jsx as _jsx } from "react/jsx-runtime";
import { OfflineButton } from './OfflineButton';
export const SettingsButton = (props) => {
    const { text, icon, onClick, color } = props;
    return (_jsx(OfflineButton, { color: color || 'primary', variant: "outlined", size: "medium", startIcon: icon, sx: {
            padding: '18px 21px',
        }, onClick: onClick, text: text }));
};
